module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-ce9f1d304f32d2cde47dc75641d9034b.png";